import { render } from "./OnlineDialog.vue?vue&type=template&id=b872a682"
import script from "./OnlineDialog.vue?vue&type=script&lang=js"
export * from "./OnlineDialog.vue?vue&type=script&lang=js"

import "./OnlineDialog.vue?vue&type=style&index=0&id=b872a682&lang=scss"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__